// extracted by mini-css-extract-plugin
export default {"container":"styles_container__6IICu","footnote":"styles_footnote__w1ADJ","grayText":"styles_grayText__71i8U","tableWrapper":"styles_tableWrapper__jz4Je"};